// actions.js
// actionTypes.js
export const OPEN_CONFIRM_DIALOG  = "OPEN_CONFIRM_DIALOG";
export const CLOSE_CONFIRM_DIALOG = "CLOSE_CONFIRM_DIALOG";

export const SHOW_TOASTER  = "SHOW_TOASTER";
export const CLOSE_TOASTER = "CLOSE_TOASTER";

export const OPEN_MODAL  = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";

export const OPEN_ALERT_MODAL  = "OPEN_ALERT_MODAL";
export const CLOSE_ALERT_MODAL = "CLOSE_ALERT_MODAL";
/* Confirm Dialog */
export const openConfirmDialog  = (payload) => ({ type: OPEN_CONFIRM_DIALOG, payload });
export const closeConfirmDialog = ()        => ({ type: CLOSE_CONFIRM_DIALOG });

/* Toaster */
export const showToaster  = (payload) => ({ type: SHOW_TOASTER, payload });
export const closeToaster = ()        => ({ type: CLOSE_TOASTER });

/* Modal */
export const openModal  = (payload) => ({ type: OPEN_MODAL, payload });
export const closeModal = ()        => ({ type: CLOSE_MODAL });

/* Alert Modal */
export const openAlertModal  = (payload) => ({ type: OPEN_ALERT_MODAL, payload });
export const closeAlertModal = ()        => ({ type: CLOSE_ALERT_MODAL });